


































































import { Component, Vue } from 'vue-property-decorator';
import leaguesService from './services/LeaguesService';

@Component({
    components: {
    },
})
export default class Leagues extends Vue {
    private leagues = [];
    private selectedLeague = 0;
    get selectedTab() {
        return this.$route.name;
    }
    private async mounted() {
        this.leagues = await leaguesService.fetchUserleagues();
        if (this.leagues.length) {
            this.selectedLeague = (this.leagues[0] as any).id;
        }
    }
}
